angular.module('jv.Candidate.Applications.Controller', [])
    .controller('jvcandidateapplicationscontroller', [
        '$scope', '$rootScope','jvCandidatesService', '$window', 'GAService','$location','jvHireUrlService',
        function($scope, $rootScope,jvCandidatesService, $window, GAService, $location, jvHireUrlService) {
            //set flag to false on load as its set to true on every routeChange
            $scope.flags.loading = false;

            //pagination cofigs
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            
            var init = function() {
                $scope.workflowUpdates = [];
                //settings up params for GET call
                var args = {
                    applicationId: $scope.applicationId,
                    readMode: ($scope.readMode || $scope.fastRead.summary) ? 0: 1,
                    allApplications : true
                };

                //Make call to fetch candidate applications
                jvCandidatesService.getCandidateApplications(args,function(response){
                    if(response && response.data.applications && response.data.applications.length){
                        $scope.applications = response.data.applications;
                        if($scope.applications.length <= $scope.pageSize){
                            $scope.hideNext = true;
                        }
                        $scope.applicationsInView = $scope.applications.slice($scope.currentPage,$scope.pageSize);
                    }
                });
            };

            init();

            $rootScope.$on('application_details_updated', function(event, forceReload) {
                if ($scope.stickyTab === 'feed' || forceReload) {
                    init();
                }
            });

            $scope.getWorkflowUpdates = function(index, applicationId) {
                var args = {
                    applicationId: applicationId,
                    readMode: ($scope.readMode || $scope.fastRead.summary) ? 0: 1
                };

                jvCandidatesService.getWorkflowUpdates(args, function(response) {
                    $scope.workflowUpdates[index] = response.data.applicationWorkflowUpdates;
                });
            };

            //Emit event that triggers the requisition quikview
            $scope.switchApplication = function(applicationId) {
                GAService.track('Switched Application');
                jvHireUrlService.navigateToCandidateDetails(applicationId, $scope.stickyTab);
            };

            $scope.numberOfSteps = function() {
                //4 steps right now.
                return new Array(4);
            };

            //pagination for  all applications widget
            $scope.paginateNext = function(pageNumber){
                $scope.currentPage = pageNumber;
                $scope.hideNext = $scope.currentPage >= Math.floor($scope.applications.length/$scope.pageSize) ? true: false;
                var start = (pageNumber*$scope.pageSize);
                var loopEnd = (start+$scope.pageSize);
                $scope.applicationsInView = [];
                for(var i=start; i < loopEnd; i++){
                     if($scope.applications[i]){
                        $scope.applicationsInView.push($scope.applications[i]);
                     }
                }
            };

            $scope.isRejected = function(workflowIndicator, index) {
                var indexFrom1 = index+1;
                var name = 'Step' + indexFrom1;
                if (workflowIndicator && workflowIndicator[name]) {
                    if (workflowIndicator[name].rejected) {
                        return true;
                    }
                }

                return false;
            };

            $scope.isCurrent = function(workflowIndicator, index) {
                if (angular.isUndefined(workflowIndicator)) {
                    return;
                }
                switch (index) {
                    case 3:
                        if (angular.isDefined(workflowIndicator.Step4))  {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isDefined(workflowIndicator.Step3))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isDefined(workflowIndicator.Step2))  {
                            return true;
                        }
                        break;
                    case 0:
                        if (angular.isDefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                    default:
                        break;
                }
                return false;
            };

            //Function to check if any of the workflow indicators should be empty. Will be making this logic smarter and moving to directive if more than 2
            //instances are required.
            $scope.isEmpty = function(workflowIndicator, index) {
                if (angular.isUndefined(workflowIndicator)) {
                    return;
                }
                switch (index) {
                    case 0:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2) && angular.isUndefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2)) {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3)) {
                            return true;
                        }
                        break;
                    case 3:
                        if (angular.isUndefined(workflowIndicator.Step4)) {
                            return true;
                        }
                        break;
                    default:
                        break;
                }
                return false;
            };
        }
]);